module.exports = __webpack_public_path__ + "annualreview2017/static/img/prosumer@2x.3df52de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prosumer@2x.png
// module id = 364
// module chunks = 0